import {Master} from './master';
import {TeklifKalem} from './teklif-kalem';
import {Irsaliye} from './irsaliye';

export class IrsaliyeKalem {

  id: number;
  irsaliyeId: number;
  adet: number;
  tutar: number;
  paraBirimiId: number;
  teklifKalemId: number;

  paraBirimi: Master;
  teklifKalem: TeklifKalem;
  irsaliye: Irsaliye;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.paraBirimi != null) {
      this.paraBirimi = new Master(obj.paraBirimi);
    }
    if (obj.teklifKalem != null) {
      this.teklifKalem = new TeklifKalem(obj.teklifKalem);
    }
    if (obj.irsaliye != null) {
      this.irsaliye = new Irsaliye(obj.irsaliye);
    }
  }
}
